import { Paper, Stack, Skeleton } from "@mui/material";

function CheckinList({ checkins, loadingCheckins }) {

    // function convertDate(date) {
    //     const [year, month, day] = date.split('-').map(Number);
    //     const d = new Date(year, month - 1, day); // month is 0-based in Date constructor
    //     const options = { weekday: 'short', month: 'long', day: 'numeric' };
    //     const formattedDate = d.toLocaleDateString('en-US', options).toUpperCase();

    //     return formattedDate;
    // }

    function convertDate(dateStr) {
        const date = new Date(dateStr);

        // Day of week (short)
        const weekday = date.toLocaleDateString("en-US", { weekday: "short" });

        // Month (long)
        const month = date.toLocaleDateString("en-US", { month: "long" });

        // Day with suffix
        const day = date.getDate();
        const suffix =
            (day % 10 === 1 && day % 100 !== 11) ? "st" :
                (day % 10 === 2 && day % 100 !== 12) ? "nd" :
                    (day % 10 === 3 && day % 100 !== 13) ? "rd" : "th";

        // Time (h:mm am/pm)
        const time = date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        }).toLowerCase();

        return `${weekday}, ${month} ${day}${suffix} at ${time}`;
    }

    return (
        <Stack>
            {loadingCheckins &&
                <Stack spacing={1} padding={2} paddingBottom={4}>
                    <Skeleton width={100} />
                    <Skeleton />
                    <Skeleton />
                </Stack>
            }
            <Stack
                spacing={1.5}
            >
                {!loadingCheckins && checkins &&
                    checkins.map((day, i) => (
                        day.checkins.map((checkin, i) => (
                            <Paper
                                elevation={0}
                                sx={{
                                    paddingTop: 2.5,
                                    paddingBottom: 2,
                                    paddingLeft: 3,
                                    paddingRight: 3,
                                    borderRadius: 2,
                                    border: '1px solid #F0ECF0',
                                    background: 'white',
                                }}
                            >
                                <Stack spacing={1}>
                                    <Stack direction="row">
                                        <span className="app-font" style={{ fontWeight: '500', color: 'rgb(100,100,100)', fontSize: '11px' }} >{convertDate(checkin.date)}</span>
                                    </Stack>
                                    <Stack direction="row" >
                                        <Stack spacing={1} sx={{ width: 1 }}>
                                            {
                                                <span key={i} className="app-font" style={{ color: '#3f0300', paddingTop: '1px', paddingBottom: '5px', whiteSpace: 'pre-line' }}>{checkin.checkin}</span>
                                            }
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Paper>
                        ))
                    ))
                }
            </Stack>
        </Stack>
    )
};

export { CheckinList };